import { useEffect, useState } from 'react'
import axios from 'axios'
import { BellRing, LoaderCircle, Save } from 'lucide-react'
import toast from 'react-hot-toast'
import { useSiteSettings } from '../hooks/useSiteSettings'

const SettingsAdminModule = () => {
  const { settings, refreshSettings } = useSiteSettings()
  const [days, setDays] = useState(settings.birthdayReminderDays)
  const [saving, setSaving] = useState(false)

  useEffect(() => setDays(settings.birthdayReminderDays), [settings.birthdayReminderDays])

  const save = async () => {
    if (!Number.isInteger(days) || days < 0 || days > 365) {
      toast.error('Le délai doit être un nombre entier compris entre 0 et 365')
      return
    }
    setSaving(true)
    try {
      await axios.put('/api/site-settings', { birthdayReminderDays: days })
      await refreshSettings()
      toast.success('Réglages enregistrés')
    } catch (error) {
      const message = axios.isAxiosError(error)
        ? error.response?.data?.message
        : undefined
      toast.error(message || "Les réglages n'ont pas pu être enregistrés")
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="space-y-6">
      <div className="max-w-3xl">
        <p className="eyebrow">Notifications automatiques</p>
        <h3 className="text-2xl font-bold text-gray-900">Rappels d’anniversaire</h3>
        <p className="mt-2 text-gray-600">
          Le rappel est envoyé à l’adresse configurée comme destinataire du formulaire de contact.
        </p>
      </div>

      <article className="card max-w-2xl">
        <div className="flex items-start gap-4">
          <span className="rounded-xl bg-emerald-100 p-3 text-emerald-800" aria-hidden="true">
            <BellRing className="h-5 w-5" />
          </span>
          <div className="min-w-0 flex-1">
            <label className="form-label" htmlFor="birthday-reminder-days">
              Nombre de jours avant l’anniversaire
            </label>
            <input
              id="birthday-reminder-days"
              className="input-field mt-2 max-w-40"
              type="number"
              min="0"
              max="365"
              step="1"
              value={days}
              onChange={(event) => setDays(event.target.valueAsNumber)}
            />
            <p className="mt-2 text-sm text-gray-500">
              Saisissez 0 pour recevoir le rappel le jour même. Un seul e-mail regroupe les anniversaires prévus à la même date.
            </p>
          </div>
        </div>
      </article>

      <div className="flex justify-end border-t border-emerald-950/10 pt-5">
        <button type="button" className="btn-primary" onClick={() => void save()} disabled={saving}>
          {saving ? <LoaderCircle className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
          Enregistrer les réglages
        </button>
      </div>
    </div>
  )
}

export default SettingsAdminModule
